<template>
  <div class="ec-page-header">
    <div 
      class="ec-page-headline" 
      v-html="headline"/>
    <div 
      v-show="description" 
      class="ec-page-description"       
      v-html="description"/>
  </div>
</template>
<script>
    export default {
        name: "PageHeader",
        props: {
            'headline': {
                type: String,
                required: true
            },
            'description': {
                default: null,
                type: String
            }
        },
        template: '#step-header-template',
    }
</script>